import React, {useRef, useState, useEffect  } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import Layout from "../../Layout/Layout";
import {activatorUserAdding, userAssUpRoleTrueRandom, isAuthenticated, getElakayLang,} from "../../auth";
import AddinfoUser from "../addUserPage/addinforUser";
import AddtelephoneUserAssociate from "../addUserPage/addTelephoneUser";
import AddAddressUserAssociate from "../addUserPage/addAdressUser";
import GetEditInfoUser from "../addUserPage/getEditInfoUser";
import Pages from '../LanguagePage'
import nodata from '../../Layout/imgs/nodata0.png';
import {laguangeElakay} from "../../pageInside/dataElakay"; 
import Modal from 'react-bootstrap/Modal';
import Timer from "../../pageInside/timer";
import ActivatorPageAss from "../addUserPage/activatorPageAss";
// import Active from "../../user/active";

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

 const incompleteProfileAlert = {
    "fr": {
      "title": "Informations incomplètes",
      "body": "Veuillez ajouter les informations manquantes (comme votre nom, prénom, email, mot de passe, téléphone et votre adresse) pour que cette case soit automatiquement cochée.",
      "link": "Cliquez ici pour compléter votre profil"
    },
    "en": {
      "title": "Incomplete information",
      "body": "Please add the missing information (such as your name, first name, email, password, phone number, and your address) so this checkbox can be automatically checked.",
      "link": "Click here to complete your profile"
    },
    "ht": {
      "title": "Enfòmasyon enkonplè",
      "body": "Tanpri ajoute tout enfòmasyon ki manke (tankou non, siyati, imel, modpas, nimewo telefòn ak adrès ou) pou ti kare sa a make otomatikman.",
      "link": "Klike la pou konplete pwofil ou"
    },
    "es": {
      "title": "Información incompleta",
      "body": "Por favor, agregue la información que falta (como su nombre, apellido, correo electrónico, contraseña, número de teléfono y dirección) para que esta casilla se marque automáticamente.",
      "link": "Haga clic aquí para completar su perfil"
    },
    "pt": {
      "title": "Informações incompletas",
      "body": "Por favor, adicione as informações ausentes (como seu nome, sobrenome, e-mail, senha, telefone e endereço) para que esta caixa seja marcada automaticamente.",
      "link": "Clique aqui para completar seu perfil"
    }
  }
 export const welcomeMessages = {
  "royalty": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As a Royalty member of Elakay",
      "body": "You are part of an elite experience. With exclusive access and privileges, your journey on Elakay will be rewarding and inspiring every step of the way."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant que membre Royalty d’Elakay",
      "body": "Vous faites partie d'une expérience unique. Avec des privilèges exclusifs, votre parcours sur Elakay sera enrichissant et mémorable."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm manm Royalty Elakay",
      "body": "Ou fè pati eksperyans elit la. Avèk aksè espesyal ak privilèj, w ap jwi chak etap sou Elakay ak fyète."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como miembro Royalty de Elakay",
      "body": "Usted forma parte de una experiencia exclusiva. Con privilegios especiales, su camino en Elakay será único y enriquecedor."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como membro Royalty do Elakay",
      "body": "Você faz parte de uma experiência de elite. Com acessos exclusivos, sua jornada será valiosa e inesquecível."
    }
  },
  "seller": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As a Seller on Elakay",
      "body": "Your products bring life to Elakay's marketplace. Through your creativity and passion, you support economic growth and empower a thriving community."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant que vendeur sur Elakay",
      "body": "Vos produits donnent vie à notre marketplace. Grâce à votre créativité et votre énergie, vous soutenez l'économie locale et la croissance partagée."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm vandè sou Elakay",
      "body": "Pwodui ou pote lavi nan platfòm lan. Ak pasyon ak kreyativite ou, ou sipòte devlopman ekonomik kominote a."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como vendedor en Elakay",
      "body": "Sus productos animan el mercado de Elakay. Con su creatividad, usted impulsa la economía y fortalece la comunidad."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como vendedor no Elakay",
      "body": "Seus produtos dão vida ao mercado Elakay. Com criatividade e dedicação, você impulsiona o crescimento econômico local."
    }
  },
  "provider": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As a Provider on Elakay",
      "body": "Your services are essential to the success of others. You offer reliability and excellence that keep Elakay running efficiently and professionally."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant que provider sur Elakay",
      "body": "Vos services sont essentiels au succès collectif. Votre fiabilité et professionnalisme assurent une plateforme efficace et fluide."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm provider sou Elakay",
      "body": "Sèvis ou enpòtan anpil pou siksè lòt yo. Ou pote efikasite ak kalite nan tout sa w ap fè sou platfòm lan."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como proveedor en Elakay",
      "body": "Sus servicios son fundamentales para el éxito de todos. Su excelencia mantiene la plataforma activa y eficaz."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como fornecedor no Elakay",
      "body": "Seus serviços são cruciais para o sucesso coletivo. Com excelência e confiança, você mantém a plataforma funcionando bem."
    }
  },
  "associate": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As an Associate on Elakay",
      "body": "You play a key role in growing and managing the network. You support users and ensure the platform thrives with balance and structure."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant qu’associate sur Elakay",
      "body": "Vous jouez un rôle essentiel dans la croissance du réseau. Vous encadrez les utilisateurs et assurez l’équilibre de la plateforme."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm associate sou Elakay",
      "body": "Wòl ou se jere ak ede kominote a grandi. Ou sipòte itilizatè yo epi ou kenbe balans ak estrikti sou platfòm lan."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como associate en Elakay",
      "body": "Usted guía el crecimiento de nuestra comunidad. Su trabajo garantiza orden, apoyo y evolución dentro de la red."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como associate no Elakay",
      "body": "Você contribui para o crescimento e equilíbrio da rede. Seu papel é apoiar e organizar a comunidade Elakay com excelência."
    }
  },
  "investment": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As an Investor of Elakay",
      "body": "Your commitment brings innovation and opportunity. You are helping build a sustainable future for digital commerce and local impact."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant qu’investisseur Elakay",
      "body": "Votre engagement stimule l’innovation et l’emploi. Vous bâtissez un avenir durable et humain pour le commerce numérique."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm envestisè sou Elakay",
      "body": "Angajman ou kreye opòtinite. Ou ap ede konstwi yon avni solid pou komès dijital ak devlopman lokal."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como inversor en Elakay",
      "body": "Su compromiso impulsa el crecimiento sostenible. Usted apoya un futuro próspero para toda la red de comercio digital."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como investidor no Elakay",
      "body": "Seu compromisso gera inovação e impacto local. Juntos, construímos um futuro econômico mais justo e sustentável."
    }
  },
  "administrator": {
    "en": {
      "accountTitle": "Your account is active",
      "headline": "Welcome {name}!",
      "subheading": "As an Administrator of Elakay",
      "body": "You are a leader and a visionary. Your decisions shape the future of the platform, and your guidance strengthens the entire ecosystem."
    },
    "fr": {
      "accountTitle": "Votre compte est actif",
      "headline": "Bienvenue {name} !",
      "subheading": "En tant qu’administrateur Elakay",
      "body": "Vous êtes un leader engagé. Vos décisions façonnent l’avenir de la plateforme et renforcent tout l’écosystème Elakay."
    },
    "ht": {
      "accountTitle": "Kont ou aktif",
      "headline": "Byenveni {name} !",
      "subheading": "Kòm administratè sou Elakay",
      "body": "Ou se yon lidè ak vizyonè. Ou gide direksyon platfòm lan e ou mete estabilite nan tout sistèm lan."
    },
    "es": {
      "accountTitle": "Su cuenta está activa",
      "headline": "¡Bienvenido {name}!",
      "subheading": "Como administrador de Elakay",
      "body": "Su liderazgo guía el rumbo de nuestra comunidad. Sus decisiones impactan cada rincón del ecosistema Elakay."
    },
    "pt": {
      "accountTitle": "Sua conta está ativa",
      "headline": "Bem-vindo {name}!",
      "subheading": "Como administrador do Elakay",
      "body": "Você é responsável por liderar e fortalecer nossa rede. Suas escolhas constroem o caminho do Elakay para o futuro."
    }
  },

  family: {
    en: {
      accountTitle: "Your account is active",
      headline: "Welcome {name}!",
      subheading: "As a Family member of Elakay",
      body: "Your presence in our community reflects trust and long-term connection. You are part of our foundation, and together we build a culture of unity, love, and collective growth."
    },
    fr: {
      accountTitle: "Votre compte est actif",
      headline: "Bienvenue {name} !",
      subheading: "En tant que membre de la Famille Elakay",
      body: "Votre présence renforce les liens humains. Ensemble, nous créons une culture de partage, de confiance et d’unité durable dans notre écosystème."
    },
    ht: {
      accountTitle: "Kont ou aktif",
      headline: "Byenveni {name} !",
      subheading: "Kòm manm fanmi Elakay",
      body: "Ou se poto mitan fanmi an. Ansanm n ap bati yon kominote ki baze sou lanmou, solidarite, ak kwasans kolektif."
    },
    es: {
      accountTitle: "Su cuenta está activa",
      headline: "¡Bienvenido {name}!",
      subheading: "Como parte de la familia Elakay",
      body: "Su conexión con nosotros es profunda. Juntos fortalecemos una comunidad basada en el respeto, la unidad y el crecimiento colectivo."
    },
    pt: {
      accountTitle: "Sua conta está ativa",
      headline: "Bem-vindo {name}!",
      subheading: "Como membro da família Elakay",
      body: "Você faz parte da nossa base afetiva. Construímos juntos uma cultura de união, confiança e prosperidade para todos."
    }
  }
};

const  welcomeMessagesSeleted = (roleName, codeLang)=>{
     const roleKey = roleName.toLowerCase();
  const lang = welcomeMessages[roleKey]?.[codeLang] ? codeLang : "en";
  const msg = welcomeMessages[roleKey]?.[lang];

  if (!msg) return null;
  return msg
}

const WelcomeAlertShow = ({ roleName, userName, codeLang, messageWelcome, setMessageWelcome }) => {
  const roleKey = roleName.toLowerCase();
  const lang = welcomeMessages[roleKey]?.[codeLang] ? codeLang : "en";
  const msg = welcomeMessages[roleKey]?.[lang];

  if (!msg) return null;

  const replaceName = (text) => text.replace("{name}", userName);

  return (
    <div className="container">
      <div className="row justify-content-center">
        <Modal
          show={messageWelcome}
          onHide={() => setMessageWelcome(false)}
          centered
        >
          <Modal.Header closeButton  style={{ background: 'LightBlue'}}>
            <Modal.Title>
              <h2 className="text-center">{msg.accountTitle}</h2>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ background: 'LightBlue'}}>
            <div>
              <h2>{replaceName(msg.headline)}</h2>
              <h4 className="text-center">{msg.subheading}</h4>
              <p>{msg.body}</p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

const  UserAddingRoleByToken = (props) => {

    const {
        infoSource
        } = props

             const location = useLocation(); // Surveille les changements d'URL
              const query = useQuery();
              const getPageBoo = (rol) => {
                    
                const role = query.get("r") || rol;
        
                return role
            };
            const autheToken = isAuthenticated()? isAuthenticated().token : null;
            const {obj} = getElakayLang();
            const {code }= obj
        let params = useParams();
        let token = params.token;
    const [loading, setLoading] = useState(false);
     const prevSearchRef = useRef(location.search);
    const [roleUser,  SetRoleUser] = useState('Royalty')
    const [userLeve, getUserleve] = useState()
    const [activePageAss, setActivePageAss] = useState(false)
    const [messageWelcome, setMessageWelcome] = useState(false)
    const [messageExp, setMessageExp] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const [planAfCh, setPlanAfCh] = useState(false);
    const [ternConCh, setTernConCh] = useState(false);
    const [agreUsIn, setAgreUsIn] = useState(false);
    const [agreeCh, setAgreeCh] = useState(false);
    const [roleNamePage, setRoleNamePage] = useState({
        plan: '',
        term:'',
        agree:'',
        role:''
    });

    let userRolle = [
        {name: 'Royalty', leve: 1}, 
        {name: 'Seller', leve: 2}, 
        {name: 'Provider', leve: 3},
        {name: 'Associate', leve: 4},
        {name: 'Investment', leve: 5}, 
        {name: 'Administrator', leve: 6},
        {name: 'Family', leve: 7}]

const {
    plan,
    term,
    agree,
    role
} = roleNamePage

    let BnPlanAffaire = {
        planAffaire : true,
        termCondition: false,
        addInfoUser: false,
        userAgree: false
    }
    let bnTermCondition ={
    planAffaire : false,
    termCondition: true,
    addInfoUser: false,
    userAgree: false
    }
    let bnAddInfoUser={
    planAffaire : false,
    termCondition: false,
    addInfoUser: true,
    userAgree: false
    }

    let bnUserAgree ={
    planAffaire : false,
    termCondition: false,
    addInfoUser: false,
    userAgree: true
    }

    const [pages, setPages]= useState(BnPlanAffaire)

    const {
        planAffaire,
        termCondition,
        addInfoUser,
        userAgree,
        } = pages

        let bninfoPersonnel ={
            infoPersonnel: true,
            telephone: false,
            AddAdress:false
        }

        let bnTelephone = {
            infoPersonnel: false,
            telephone: true,
            AddAdress:false
            }

        let bnAddAdress ={
            infoPersonnel: false,
            telephone: false,
            AddAdress:true
            }

        const [pagesUser, setPagesUser]= useState(bninfoPersonnel)

        const { 
            infoPersonnel,
            telephone,
            AddAdress  
        } = pagesUser

          const divInfoRoll = useRef(null);
        
        const scrollToParagraph = (ref) => {
                ref.current.scrollIntoView({ behavior: 'smooth' });
              };

        useEffect(() => {  
           
            const currentSearch = location.search;
            if (prevSearchRef.current !== currentSearch) {
                chosingRolePage(getPageBoo(roleUser))
                prevSearchRef.current = currentSearch; // Met à jour la valeur précédente
            }
            // chosingRolePage(roleUser)
            loadingUserAct(token, '', '', false, false)
        }, [location.search, token, roleUser]);

        // let  paragra0 =  !infoSource.loading &&  infoSource.languageAPI.elakayInfoAPI

        let telephone1 = {
            country: 'United States',
            abrCountry: 'US',
            ariaCode: '1',
            National: '(347) 781-3174',
            International: '+1 347 781 3174'
        }
        let userA = {firstname: "Yves", lastname: "Oxilus", password: 'userElakay2018' }

       let address = {
              firstName: 'intel',
              lastName: 'travail',
              shopName: null,
              tel: '+1 347 781 3174',
              Address1: '1091 Hancock st',
              Address2: '',
              city: 'Brooklyn',
              State: 'New York',
              postalCode: '11221',
              country: 'US'
            }

        const loadingUserAct = (token, key, value, save, relaod) => {
            activatorUserAdding(token, key, value, save)
                .then(data => {
                    if (data.error) {
                        
                        setMessageExp(true)
          setTimeout(() => {
                       if (!autheToken) {
                        setMessageWelcome(false);
                        } else {
                     
                      const userInfo = infoSource.userInfo;
                      const activeRole = userInfo?.userActiveRole;

                      // Vérifie que userInfo et userActiveRole ne sont pas vides
                      if (
                        userInfo &&
                        activeRole &&
                        Object.keys(activeRole).length > 0 
                      ) {
                        setUserInfo(userInfo);
                        SetRoleUser(activeRole.roleName);
                        getUserleve(activeRole.level);
                        chosingRolePage(activeRole.roleName);
                        setMessageWelcome(true);
                      } else {
                        console.warn("Role non défini ou incomplet.");
                        setMessageWelcome(false);
                      }
                  }
                        }, 3000);  
                        console.log(data.error)
                    } else {     
                      localStorage.setItem("token_userAdding", token);
                        setMessageExp(false)
                        checkAllInfoEnt(data)
                        setUserInfo(data)
                        SetRoleUser(data.userActiveRole.roleName)
                        getUserleve(data.userActiveRole.level)
                        chosingRolePage(data.userActiveRole.roleName)
                        relaod &&  setPagesUser(bninfoPersonnel)
                    }
                });
        };
        
        const chosingRolePage =(a)=>{
            setPages(BnPlanAffaire)
            if(a === 'Royalty'){
                setRoleNamePage({
                    plan: 'planUserRoyal',
                    term:'termConditionRoyal',
                    agree:'royalAgree',
                    role: a
                })
            }else if(a === 'Seller'){
                setRoleNamePage({
                    plan: 'planUserSeller',
                    term: 'termConditionSeller',
                    agree: 'sellerAgree',
                    role: a
                })
            }else if(a === 'Provider'){
                setRoleNamePage({
                    plan: 'planUserProvider',
                    term: 'termConditionProvider',
                    agree: 'providerAgree',
                    role: a
                })
            }else if(a === 'Associate'){
                setRoleNamePage({
                    plan: 'planAffaireElakay',
                    term:'termConditionAssociate',
                    agree:'associateAgree',
                    role: a
    
                })
            }else if(a === 'Investment'){
                setRoleNamePage({
                    plan: 'planProInvestElakay',
                    term:'termConditionInvest',
                    agree:'investmentAgree',
                    role: a
                })
            }else if(a === 'Administrator'){
                setRoleNamePage({
                    plan: 'planProAdminElakay',
                    term:'termConditionAdmin',
                    agree:'AdministratorAgree',
                    role: a
                })
            }else if(a ==='Family'){
                setRoleNamePage({
                    plan: 'planAffaireFamily',
                    term:'termConditionFamily',
                    agree:'familyAgree',
                    role: a
                })
            }

        }

        const handleUserRole =()=> event =>{
            let userRole = event.target.value;
            chosingRolePage(userRole)
        }

            const bonPrev = (a, t = true)=>{
              return  t?<button onClick={()=> {setPages(a); scrollToParagraph(divInfoRoll)}} className="btn btn-primary p-2 float-left" style={{ width: "120px" }}>
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).previous}
              </button>: <button onClick={()=> {setMessageExp(true); scrollToParagraph(divInfoRoll)}} className="btn btn-primary p-2 float-left" style={{ width: "120px" }}>
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).previous}
             </button>
            }
           const  bonNext = (a, t = true)=>{
               return t? <button onClick={()=> {setPages(a); scrollToParagraph(divInfoRoll)}} className="btn btn-primary p-2 float-right" style={{ width: "120px" }}>
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
             </button> : <button onClick={()=> {setMessageExp(true); scrollToParagraph(divInfoRoll)}} className="btn btn-primary p-2 float-right" style={{ width: "120px" }}>
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
             </button>
            }

            const allBon = (p, n, t)=>{
                return  <div className="row justify-content-center m-4">
                <div className="col col-sm-10">
                    <div className="bg clearfix ">
                        { p && bonPrev(p, t)}
                        {n && bonNext(n, t)}
                    </div>
                </div></div>
            }
            const checkObjEmpty =(obj)=>{
                if(Object.values(obj ? obj: []).length > 0){
                    
                    return true
                }else {
                    // setMessageExp(true)
                    return false
                }
                
                }

            const checkProdKeyExit = (ad)=>{
                let ent 
                if(Array.isArray(ad)){
                  let ac = ad[0]
                  ent = Object.keys(ac ? ac:{});
                  return ent.every(([key, val]) => ac[key] != undefined) && true
                } else{
                   ent = Object.keys(ad ? ad:{});
                   return ent.every(([key, val]) => ad[key] != undefined) && true
                }}
        
        
                const isNotEmptyObject = (obj) =>
  obj && typeof obj === 'object' && Object.keys(obj).length > 0;

        const shouldShowWelcomeMessage = (messageWelcome, userInfo) => {
        return !!(
            messageWelcome === true &&
            isNotEmptyObject(userInfo) &&
            isNotEmptyObject(userInfo.userActiveRole)
        );
};
            const pageSteps = (a)=>{
                    if (!checkProdKeyExit(a)){
                       return <Pages  
                       classAlert ={'container'}
                        paragra0={a}
                    />
                    }else{
                      return <div> 
                      <div className="row mt-4 mb-4 justify-content-center">
                        <div className="col-11">
                      <img className="shadow-lg" style={{ width: "100%" }} src={nodata} alt="firt Step" />
                       </div>
                       </div></div>
                    }
                }


         const  planAffairePage =()=>{
                return planAffaire && <div ref={divInfoRoll}>
                    {pageSteps(infoSource.laguangeElakay(plan,  infoSource.languageAPI))}
                    {  allBon(undefined, bnTermCondition)}
                    </div> 
            }     


            const  termConditionPage =()=>{
                return termCondition && <div ref={divInfoRoll}>
                       {pageSteps(infoSource.laguangeElakay(term,  infoSource.languageAPI))}
                   
                    {  allBon(BnPlanAffaire, bnAddInfoUser, checkObjEmpty(userInfo))}
                    </div> 
            }
            
            const ckeckIfEdit =(k, AO, B )=>{
                if(k == 'userInfo'&& B){
                    if(AO.firstName != 'user' &&  AO.lastName != 'elakay') {
                     return true
                    } else if(AO.firstName != undefined && AO.lastName != undefined){
                        return true
                    }else{
                        return false        
                }
            } else if(k == 'telephone'&& B){
                if(AO.length == 0){
                    return true
                } else {
                    return false
                }  
            }else if(k == 'address'&& B){
                if(AO.length == 0){
                    return true
                } else {
                    return false
                }  
            }
        }
        
            const checkObjEmpty1 =(obj)=>{
               let arry = obj && Object.values(obj)
         
                }
                const relaodFonctionToken =()=>{
                        loadingUserAct(token, '', '', false, false)
                         setPages(bnAddInfoUser)
                }


                const resteAllData =(a)=>{

                    checkAllInfoEnt(a)
                    setUserInfo(a)
                    // setPages(bnAddInfoUser)
                  //  setTimeout(() => { setPages(bnAddInfoUser)   }, 1500);

                }
                
                const checkAllInfoEnt = (obj)=>{
                    let emailTel = obj.telephoneSing ? obj.telephoneSing.International.replaceAll(' ', '')+'@elakay.com': undefined
                    const allowed = ['firstname', 'lastname', 'email']
                    const allowedTel = ['country', 'abrCountry', 'ariaCode', 'National', 'International']
                    const allowedAdr = ['firstName', 'lastName', 'tel', 'Address1', 'city', 'State', 'postalCode', 'country'] 
                    let val = obj['firstname'] == 'user'&& obj['lastname'] == 'elakay' && obj['email'] == emailTel
                    let valArr = allowed.every((ar)=>  obj[ar] != '' && obj[ar] != undefined)
                    let valTel = allowedTel.every((ar)=> obj['telephone'].length > 0 &&  obj['telephone'][0][ar] != '' || obj['telephone'].length > 0 &&  obj['telephone'][0][ar] != undefined)
                    let valAdr = allowedAdr.every((ar)=> obj['address'].length > 0 &&  obj['address'][0][ar] != '' || obj['address'].length > 0 && obj['address'][0][ar] != undefined)
                    !val &&  valArr &&  valTel &&  valAdr && setAgreUsIn(true)
                }

        const checkInfoUser = (obj, ele, pa, upt, ifu)=>{

            let emailTel = obj.telephoneSing ? obj.telephoneSing.International.replaceAll(' ', '')+'@elakay.com': undefined
    
            let val = obj[ele] == 'user' || obj[ele] == 'elakay' || obj[ele] == emailTel || obj[ele] == undefined || obj[ele] == '' 
        
            let contunue 
           if(pa == 'edit'){
               if( obj && obj[ele] && val){
                contunue = false
               }else{
                contunue = true
               }
            }else if(pa == 'userInfo'){
                let a = obj && obj[ele] && !val && ifu && upt 
             
                a && setPagesUser(bnTelephone)
                contunue = true
            }else if(pa == 'telephone'){
                let a = obj && checkObjEmpty(obj[pa][0]) && !val && ifu && upt 
                a && setPagesUser(bnAddAdress)
                contunue = true
            }
            else if(pa == 'address'){
                let a = obj && checkObjEmpty(obj[pa][0]) && !val && ifu && upt
                a ? contunue = false : contunue = true
            }
            return  contunue

        }
        

    const  IncompleteProfileAlert = (lang = "en") => {
  const alertData = incompleteProfileAlert[lang] || incompleteProfileAlert["en"];

  return (
    <div className="alert alert-warning" role="alert">
      <strong><span style={{ fontSize: "30px", lineHeight: "1" }}>↑</span>{alertData.title}:</strong><br />
      {alertData.body}<br />
      👉 <a onClick={()=> {setPages(bnAddInfoUser); scrollToParagraph(divInfoRoll)}} className="alert-link">{alertData.link}</a>
    </div>
  );
};
        

            const planAddInfoUser =()=>{
                return checkObjEmpty(userInfo) && addInfoUser &&  <div ref={divInfoRoll}> 
         {         checkObjEmpty(userInfo) &&  <GetEditInfoUser
                     setPagesUser={setPagesUser}
                     setUserInfo={resteAllData} 
                    bnTelephone={bnTelephone}
                    checkObjEmpty={checkObjEmpty}
                    checkInfoUser={checkInfoUser}
                    relaodFonctionToken={relaodFonctionToken}
                    userInfo={userInfo}
                      token={token}
                      infoSource={ infoSource}
                      loadingUserAct={loadingUserAct}
                    />}
              {   checkInfoUser(userInfo, 'firstname', 'userInfo', infoPersonnel, addInfoUser) &&  infoPersonnel && < AddinfoUser
                    setPagesUser={setPagesUser}
                    bnTelephone={bnTelephone}
                    setUserInfo={resteAllData}
                    userInfo={userInfo}
                     infoSource={ infoSource}
                     checkInfoUser={checkInfoUser}
                     token={token}
                    />}

              { checkInfoUser(userInfo, 'firstname', 'telephone', telephone, addInfoUser) && telephone &&  <AddtelephoneUserAssociate 
                     setPagesUser={setPagesUser}
                     bnAddAdress={bnAddAdress}
                     setUserInfo={resteAllData}
                     infoSource={ infoSource}
                     token={token}
                    />}

              {  checkInfoUser(userInfo, 'firstname', 'address', AddAdress, addInfoUser) && AddAdress &&  <AddAddressUserAssociate
                     setPagesUser={setPages}
                     bnTelephone={bnUserAgree}
                     setUserInfo={resteAllData}
                      infoSource={ infoSource}
                      fullName={{firstname: userInfo.firstname, lastname: userInfo.lastname}}
                      phoneUser={userInfo.telephone}
                      token={token}
                    />}
                    {  allBon(bnTermCondition, bnUserAgree)}
                    </div> 
            }
            let nbrDayRestant = checkObjEmpty(userInfo) ? Math.abs(new Date(userInfo.ativator[0].experyDate) - new Date()) : 0
            let endDays = checkObjEmpty(userInfo) ? new Date(userInfo.ativator[0].experyDate).getTime() : 0
            let startDays = checkObjEmpty(userInfo) ? new Date(userInfo.createdAt).getTime(): 0

            // if(nbrDayRestant === 0){
            //     setMessageExp(true)
            // }

            const  CheckBoxButton = ()=>{
                let c = planAfCh? false: true
                setPlanAfCh(c) 
             }
             const  CheckBoxButton0 = ()=>{
                let c = ternConCh? false: true
                setTernConCh(c) 
             }
             const  CheckBoxButton1 = ()=>{
                let c = agreeCh? false: true
                setAgreeCh(c) 
             }


    const clickAgree = () => {
        setActivePageAss(true)
        userAssUpRoleTrueRandom(token).then(data => {
            if (data.error) {
                console.log(data.error)
            } else {
                console.log("data")
            }
        })


    }
             const  sendCodeBnt = ()=>{
                return planAfCh && ternConCh && agreeCh && agreUsIn ? 
                <button onClick={()=> clickAgree()} className="btn btn-primary p-2 float-right" style={{ width: "120px" }}>
                {/* active user */}
                {infoSource.language(infoSource, "Button", "actUser")} 
              </button> : <button className="btn btn-primary p-2 float-right disabled" style={{ width: "120px" }}>
              {/* active user */}
              {infoSource.language(infoSource, "Button", "actUser")} 
              </button>
             }

            
        
            const userAgreePage =()=>{
                return userAgree && <div ref={divInfoRoll}>
                    {pageSteps(infoSource.laguangeElakay(agree,  infoSource.languageAPI))}
                    <div className="container">
                    <div className="row mb-4 justify-content-center">
                    <ul className="col-12 col-md-9">
                            <li className="list-unstyled"> 
                            <input
                                    onChange={CheckBoxButton}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={planAfCh? 'checked' : ''}
                                    id="planAffairLu"
                                />
                                <label className="form-check-label" for="planAffairLu">
                                    {/* es ce que vous avez lu le plan d'affaire  */}
                                    {infoSource.language(infoSource, "label", "planAffairLu")}
                                    </label>
                            </li>
                            <li className="list-unstyled">
                            <input
                                    onChange={CheckBoxButton0}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={ternConCh? 'checked' : ''}
                                    id="termConditionAgre"
                                />
                                <label className="form-check-label" for="termConditionAgre">
                                    {/* es ce que vous ete d'acord avec les term et les condition */}
                                    {infoSource.language(infoSource, "label", "termConditionAgre")}
                                    </label>
                            </li>
                            <li className="list-unstyled">
                            <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={agreUsIn? 'checked' : ''}
                                    id="allInfoOk"
                                />
                                <label className="form-check-label" for="allInfoOk">
                                    {/* tous les user information are ok  */}
                                    {infoSource.language(infoSource, "label", "allInfoOk")}
                                    </label>
                                    {!agreUsIn && IncompleteProfileAlert(code)}
                            </li>
                            <li className="list-unstyled">
                                <input
                                    onChange={CheckBoxButton1}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={agreeCh? 'checked' : ''}
                                    id="chButAgree"
                                />
                                <label className="form-check-label" for="chButAgree">
                                {infoSource.language(infoSource, "title", "chButAgree")}
                                     {/* avec le deux volet pour continue */}
                                     {infoSource.language(infoSource, "label", "acpContinue")}
                                     </label>
                            </li>
                        </ul>
                        
                    </div>
                    {sendCodeBnt()}
                    </div>
                    {  allBon(bnAddInfoUser, undefined, checkObjEmpty(userInfo))}
                    </div> 
            }




                let emptyObjStyle ={
                    position:"relative",
                    width: "323.52px",
                    height: "204px",
                    backgroundColor:"#191970",
                    background: "radial-gradient(ellipse at right bottom, #0077b3 10%, #80d4ff 30%,  #66ccff 70%, #1ab2ff 100%)", 
                    margin: "10px",
                    borderRadius:"15px",
                    color: "white",
                    boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.5)"
                }
            const allform =()=>{
               return <div  className="row mt-4 mb-4 justify-content-center">
                <div className="col col-12 col-md-12 col-lg-11 col-xl-11 p-0" style={{border: "1px solid Gainsboro" }} >
                 {checkObjEmpty(userInfo) && <Timer
                        infoSource={infoSource}
                        setMessageExp ={setMessageExp}
                        message ={welcomeMessagesSeleted(shouldShowWelcomeMessage(messageWelcome, userInfo)? userInfo.userActiveRole.roleName: 'Royalty', code)}
                        messageWelcome={autheToken ? true : false}
                        nbrdays = {nbrDayRestant} 
                        startDate={endDays}
                        enDate={endDays}
                        />}

                        {!checkObjEmpty(userInfo) &&  <Timer
                         infoSource={infoSource}
                        setMessageExp ={setMessageExp}
                        nbrdays = {nbrDayRestant}
                       
                        />
                    }
        
                
                {planAffairePage()}
                {termConditionPage()}
                {planAddInfoUser()}
                {userAgreePage()}
                 </div>
                 </div>
            
            }



            const activaTorPageForm = () => (
                <div className="contaire">
                    <div className="row justify-content-center " >
                        <Modal
                            size="lg"
                            show={activePageAss}
                            onHide={() => setActivePageAss(false)}
                            dialogClassName="modal-90w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>

                            <ActivatorPageAss
                             laguangeElakay={ laguangeElakay}
                             infoSource={infoSource}
                             token={token}
                            />
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            )
            const expireLink = () => (
                <div className="contaire">
                    <div className="row justify-content-center ">
                        <Modal
                            size="lg"
                            show={messageExp && !autheToken}
                            onHide={() => setMessageExp(false)}
                            // dialogClassName="modal-90w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton style={{background: 'Beige'}}>
                                <Modal.Title id="example-custom-modal-styling-title" >
                                    <h2>
                                        {/* Votre Compte est expire */}
                                        {infoSource.language(infoSource, "title", "compExp")}
                                        </h2>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{background: 'Beige'}}>

                                {/* <h4> */}
                                {/* Hello chere Partenaire */}
                                {/* {infoSource.language(infoSource, "title", "hellPart")} */}
                                {/* </h4>
                                 <p> */}
                                {/* Nous souhaitons vous informer que le lien precedemment partage pour rejoindre l’equipe de Elakay n’est plus actif et ne peut plus être utilise pour l’inscription. */}
                                {/* {infoSource.language(infoSource, "text", "textAdUserRoToken")} */}
                                {/* </p>
                                <p> */}
                                {/* Cependant, vous avez toujours la possibilite de consulter notre plan d’affaires ainsi que les thèmes et conditions associes. Ces documents restent accessibles et peuvent vous fournir des informations precieuses sur notre projet et nos objectifs. */}
                                {/* {infoSource.language(infoSource, "text", "textAdUserRoToken0")} */}
                               {/* </p> 
                               <p> */}
                                {/* Nous nous excusons pour tout desagrement cause et vous remercions de votre interêt pour Elakay. Pour toute question ou si vous souhaitez obtenir des informations supplementaires, n’hesitez pas à nous contacter. */}
                                {/* {infoSource.language(infoSource, "text", "textAdUserRoToken1")} */}
                            {/* </p> */}
                           <Link className=" m-4 btn btn-dark btn-md py-1 px-3 rounded-4" to="/signin" style={{color:'#ffffff', backgroundColor: '#007399', position:'relative', padding: '8px', textAlign: "center", fontSize: "1.2rem"}}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).signin}</Link>

                           <Link className=" m-4 btn btn-dark btn-md py-1 px-3 rounded-4" to="/" 
                            style={{
                                color: '#ffffff',
                                backgroundColor: '#007399',
                                position: 'relative',
                                padding: '8px',
                                textAlign: 'center',
                                fontSize: '1.2rem',
                                textTransform: 'lowercase' // 👈 ceci force le texte en minuscules
                              }}>
                            elakay
                            </Link>
                                {/* <button onClick={() => setMessageExp(false)}>
                                   {infoSource.laguangeElakay('Button', infoSource.languageAPI).continue}
                                </button> */}
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            )

        

            let plsh = planAffaire || termCondition || addInfoUser|| userAgree ? "active" : ''
            let tcsh = termCondition || addInfoUser|| userAgree ? "active" : ''
            let insh = addInfoUser|| userAgree ? "active" : ''
            let Agsh = userAgree ? "active" : ''
            const stepSeller = ()=>(
                // <div className="boxCategory1 text-center">
           <div className="row justify-content-center mt-3">
          <div className="col-xs-12 col-md-8">
            <div className="wrapper-progressBar">
                <h2>
                    {/* all to Know about  */}
                    {infoSource.language(infoSource, "label", "allKnowAbout")}{' '}
                    {role} </h2>
                    <div className="row m-3">
   {  checkObjEmpty(userInfo)  && <select value={role} onChange={handleUserRole()} className="form-select " aria-label="Default select example">
  {userRolle.filter(item =>item.leve <= userLeve).map((s, i)=>{
   return <option value={s.name}>{s.name}</option>
  })}
</select>}</div>
              <ul className="progressBar mt-4">
                <li className={plsh} onClick={()=> setPages(BnPlanAffaire)}>
                    {/* Plan D'affaire */}
                    {infoSource.language(infoSource, "label", "planAffai")}
                    </li>
                <li className={tcsh} onClick={()=> setPages(bnTermCondition)}>
                    {/* Term & Condition */}
                    {infoSource.language(infoSource, "label", "termCondi")}
                    </li>
                <li className={insh} onClick={()=>setPages(bnAddInfoUser)}>
                    {/* Add your info */}
                    {infoSource.language(infoSource, "label", "AddInfo")}
                    </li>
                <li className={Agsh} onClick={()=> setPages(bnUserAgree)}>
                    {/* Final Agree */}
                    {infoSource.language(infoSource, "label", "FinalAgree")}
                    </li>
              </ul>

              
            </div>
          </div>
        </div>
            )

    return (
        <Layout
            infoSource ={infoSource}
            title="Home Page"
            description="Node React E-commerce App"
            className="container-fluid"
            loading={loading}
            SliderPunShow={false}
        >
        <div style={infoSource.styleNav}>
            {stepSeller()}
            {expireLink()}
            {allform()}
            {activaTorPageForm()}
{messageWelcome && <WelcomeAlertShow
  roleName={shouldShowWelcomeMessage(messageWelcome, userInfo)?  userInfo.userActiveRole.roleName: 'Royalty'}
  userName={shouldShowWelcomeMessage(messageWelcome, userInfo)? userInfo.firstname +' ' + userInfo.lastname: "ass"}
  codeLang={code}
  messageWelcome={messageWelcome}
  setMessageWelcome={setMessageWelcome}
/>}
        </div>
         </Layout>
    );
};

export default  UserAddingRoleByToken;